import { render, staticRenderFns } from "./PageEventGiftForm.vue?vue&type=template&id=2b411e2a&scoped=true&"
import script from "./PageEventGiftForm.vue?vue&type=script&lang=js&"
export * from "./PageEventGiftForm.vue?vue&type=script&lang=js&"
import style0 from "./PageEventGiftForm.vue?vue&type=style&index=0&id=2b411e2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b411e2a",
  null
  
)

export default component.exports